import type { ActivityEventDTO } from "@jaiho/shared";

/** Renders a structured activity event into display text — the server never sends preformatted English strings. */
export function formatActivityEvent(event: ActivityEventDTO): string {
  switch (event.type) {
    case "LEVEL_UP": {
      const toLevel = event.payload["toLevel"];
      return `${event.actor.displayName} reached Level ${typeof toLevel === "number" ? toLevel : "?"}`;
    }
    case "ACHIEVEMENT_UNLOCKED": {
      const name = event.payload["achievementName"];
      return `${event.actor.displayName} unlocked "${typeof name === "string" ? name : "an achievement"}"`;
    }
    default:
      return `${event.actor.displayName} did something`;
  }
}
